<template>
  <div class="transaction-container" :class="{ selected: isSelected && isTransactionEditable }">
    <div @click="canEditCategory && toggleActions()"><transaction-row :transaction="transaction" :can-edit-category="canEditCategory"
                      :category-name="categoryName" :category-id="categoryId" :isSelected="isSelected"/>
    </div>
    <actions :actions="actions" :category-name="categoryName" v-if="isSelected && isTransactionEditable"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TransactionRow from './TransactionRow.vue';
import Actions from '../../../../../../../../../base-components/Actions.vue';
import Segment from '../../../../../../../../../Segment';
import ChangeTransactionCategoryPopup from '../../../current-month/components/cashflow-edit/edit-transaction/ChangeTransactionCategoryPopup.vue';
import ModalBus from '../../../../../../../../../event-bus/modal-bus';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';

export default {
  name: 'Transaction',
  props: [
    'transaction',
    'canEditCategory',
    'categoryName',
    'categoryId',
  ],
  components: {
    TransactionRow,
    Actions,
  },
  computed: {
    ...mapState('cashflowView', ['actionsExpandedFor']),
    isIncome() {
      return this.transaction.isIncome;
    },
    isExcludedCategory() {
      return this.categoryName === cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_INCOME
          || this.categoryName === cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_EXPENSE;
    },
    actions() {
      const icon = this.isExcludedCategory ? 'edits-exclude' : 'edits-move';
      const onClick = this.openEditCategory;
      const text = (() => {
        if (this.isExcludedCategory) {
          return 'להעביר בחזרה לתזרים';
        }
        if (this.isIncome) {
          return 'להעביר הכנסה למקום אחר';
        }
        return 'להעביר הוצאה למקום אחר';
      })();

      return [{ text, icon, onClick }];
    },
    isTransactionEditable() {
      return this.canEditCategory;
    },
    isSelected() {
      return this.actionsExpandedFor === this.transaction.transactionId;
    },
  },
  methods: {
    ...mapActions('editTransaction', ['startEditingTransaction']),
    ...mapActions('cashflowView', ['expandActionsOf']),
    toggleActions() {
      if (this.isSelected) {
        this.expandActionsOf(null);
      } else {
        this.expandActionsOf(this.transaction.transactionId);
      }
    },
    openEditCategory() {
      Segment.trackUserInteraction('EditTransactionClicked', { businessName: this.transaction.businessName });
      this.startEditingTransaction({
        transaction: this.transaction,
        categoryName: this.categoryName,
        categoryId: this.categoryId,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
  },
};

</script>

<style scoped lang="scss">
    @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .transaction-container {
    background-color: $riseup_gray_0;
    &.selected {
      background-color: $riseup_v2_light_grey;
    }
    border-bottom: 1px solid $riseup_white;
    &:first-of-type {
      box-shadow: inset 0 2px 3px 0 rgba(155, 155, 155, 0.51);
    }
    &:last-of-type {
      border-bottom: none;
    }
  }

</style>
